// Enums
import { TrackingDataFieldTypeLoginMethod } from '@shopee-user/tracking-login';
import { AuthenticateChannel } from '@tob/shared/thirdparty-auth/core/types';
import { LoginTrackingPoint } from '@shopee-user/tracking-constants';
import { ThirdpartyBindingEntryPoint } from '@tob/shared/thirdparty-auth/service/constants';
import {
  LoginMethod,
  BusinessPage,
} from '@tob/shared/monitoring/business-metric/enums';

export const convertChannelToTrackingInfo = (channel: AuthenticateChannel) => {
  switch (channel) {
    case AuthenticateChannel.Shopee:
      return {
        loginMethod: TrackingDataFieldTypeLoginMethod.ThirdPartyShopee,
        targetType: 'third_party_shopee',
        trackingPoint: LoginTrackingPoint.LoginWithThirdPartyShopee,
      };
    case AuthenticateChannel.Google:
      return {
        loginMethod: TrackingDataFieldTypeLoginMethod.ThirdPartyGoogle,
        targetType: 'third_party_google',
        trackingPoint: LoginTrackingPoint.LoginWithThirdPartyGoogle,
      };
    case AuthenticateChannel.Facebook:
      return {
        loginMethod: TrackingDataFieldTypeLoginMethod.ThirdPartyFacebook,
        targetType: 'third_party_facebook',
        trackingPoint: LoginTrackingPoint.LoginWithThirdPartyFacebook,
      };
    case AuthenticateChannel.Apple:
      return {
        loginMethod: TrackingDataFieldTypeLoginMethod.ThirdPartyApple,
        targetType: 'third_party_apple',
        trackingPoint: LoginTrackingPoint.LoginWithThirdPartyApple,
      };
    default:
      return {};
  }
};

// Monitoring
export const toMonitoringLoginMethod = (
  channel: AuthenticateChannel
): LoginMethod | undefined => {
  switch (channel) {
    case AuthenticateChannel.Shopee:
      return LoginMethod.Shopee;
    case AuthenticateChannel.Google:
      return LoginMethod.Google;
    case AuthenticateChannel.Facebook:
      return LoginMethod.Facebook;
    case AuthenticateChannel.Apple:
      return LoginMethod.Apple;
    default:
      return undefined;
  }
};

// Bind/unbind-only entry points (AccountSettingPage, ThirdPartyBindSharedService)
// and Unknown are not login attempts and must not report a business_page.
//
// TODO: ThirdpartyBindingEntryPoint.LoginByPasswordPage/LoginByOtpPage is passed
// identically by the pure-ToB, one-credential, and one-credential-optional page
// variants (e.g. login-by-password, login-by-password-one-credential,
// login-by-password-one-credential-optional all pass LoginByPasswordPage), so
// this can only ever resolve to the base BusinessPage.LoginByPassword/LoginByOtp,
// never the *OneCredential/*OneCredentialOptional variants BusinessPage already
// distinguishes. Fixing this properly requires new ThirdpartyBindingEntryPoint
// values per variant, updating every page's entryPoint prop, and updating
// BindingSuccess's switch too (tob-web/src/pages/third-party-service/components/BindingSuccess/index.tsx) —
// tracked as a known limitation, not fixed in this task.
export const toMonitoringBusinessPage = (
  entryPoint: ThirdpartyBindingEntryPoint
): BusinessPage | undefined => {
  switch (entryPoint) {
    case ThirdpartyBindingEntryPoint.LoginByPasswordPage:
      return BusinessPage.LoginByPassword;
    case ThirdpartyBindingEntryPoint.LoginByOtpPage:
      return BusinessPage.LoginByOtp;
    case ThirdpartyBindingEntryPoint.SignupByOtpPage:
      return BusinessPage.SignupByOtp;
    case ThirdpartyBindingEntryPoint.ReloginPage:
      return BusinessPage.Relogin;
    default:
      return undefined;
  }
};
